import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from 'routes';
import styled from 'styled-components';
import { Heading, Text } from '@higo/ui';
import {
  SetNewPinFormModel,
  SetNewPinNumberForm,
} from 'pages/SetPinPage/SetNewPinNumberForm';
import { RoleType } from '@higo/api/lib/models/roleType';
import { useSetPatientPinMutation } from './hooks/useSetPatientPinMutation';
import { useSetUserPinMutation } from './hooks/useSetUserPinMutation';

const StyledText = styled(Text)`
  margin-bottom: 1.5rem;
`;

export type SetNewPasswordPageParams = {
  token: string;
};

interface SetNewPinNumberPageProps {
  roleType: RoleType;
}

export const SetNewPinNumberPage: FC<SetNewPinNumberPageProps> = ({
  roleType,
}) => {
  const { token } = useParams<SetNewPasswordPageParams>();
  const navigate = useNavigate();
  const patientPinMutation = useSetPatientPinMutation();
  const userPinMutation = useSetUserPinMutation();

  if (!token) {
    navigate(routes.root);
    return null;
  }

  const requestSetPinNumber = ({ pin, pinConfirmation }: SetNewPinFormModel) =>
    roleType === RoleType.Patient
      ? patientPinMutation
          .mutateAsync({
            newPin: pin,
            repeatNewPin: pinConfirmation,
            token,
          })
          .then(() => {
            navigate(routes.root);
          })
      : userPinMutation
          .mutateAsync({
            newPin: pin,
            repeatNewPin: pinConfirmation,
            token,
          })
          .then(() => {
            navigate(routes.root);
          });

  return (
    <>
      <Heading level={1}>
        <FormattedMessage id="authentication.pinCodeHeader" />
      </Heading>
      <StyledText variant="body2">
        <FormattedMessage id="authentication.setPinCode.description" />
      </StyledText>
      <SetNewPinNumberForm onSubmit={requestSetPinNumber} />
    </>
  );
};
